import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

export const StakingScreenSchema = yup
	.object({
		sourceStakeAccountAddress: yup.string().default('').required(),
		currency: yup.string().default(''),
		note: yup.string().default('').required(),
		createdAt: yup.date().default(undefined),
	})
	.defined();

export type StakingForm = yup.TypeOf<typeof StakingScreenSchema>;

export function useStakingScreenForm() {
	return useForm<StakingForm>({
		mode: 'onBlur',
		resolver: yupResolver(StakingScreenSchema),
		defaultValues: StakingScreenSchema.cast({}),
	});
}
